<template>
<div>
  <v-layout>
    <v-btn color="info" @click="downloadCryptoTradersExcel">
      Download Crypto Traders
    </v-btn>
  </v-layout>
  <!-- TABLE -->
  <v-layout row wrap justify-space-around>
    <v-flex xs2>
      <v-text-field
        append-icon="search"
        label="Search by first name"
        v-model="search.firstName"
      />
    </v-flex>
    <v-flex xs2>
      <v-text-field
        append-icon="search"
        label="Search by last name"
        v-model="search.lastName"
      />
    </v-flex>
    <v-flex xs2>
      <v-text-field
        append-icon="search"
        label="Search by email"
        v-model="search.email"
      />
    </v-flex>
    <v-flex xs2>
      <v-select
        :items="registrationStatuses"
        v-model="search.registrationStatus"
        label="Crypto Trader Status"
      />
    </v-flex>
  </v-layout>
  <v-data-table
    v-if="getCryptoTradersList"
    :rows-per-page-items="pageRows"
    :headers="headers"
    :items="getCryptoTradersList"
    class="elevation-1 wrap"
    :pagination.sync="pagination"
    :total-items="totalItemsInTable"
    :loading="loading"
    item-key="id"
    :disable-initial-sort="true"
  >
    <template slot="items" slot-scope="props">
      <tr>
        <td class="py-4">{{ props.item.firstName }}</td>
        <td class="py-4">{{ props.item.lastName }}</td>
        <td class="py-4">{{ props.item.email }}</td>
        <td class="py-4">{{ props.item.registrationStatus }}</td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="lime"
              fab flat
              slot="activator"
              @click.stop="editCryptoTrader(props.item)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="deep-orange "
              fab flat
              slot="activator"
              @click="setStatusReject(props.item.id)">
              <v-icon>pan_tool</v-icon>
            </v-btn>
            <span>Reject user</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="red accent-4"
              fab flat
              slot="activator"
              @click.stop="showConfirmationDeleteForever(props.item)"
            >
              <v-icon>delete_forever</v-icon>
            </v-btn>
            <span>Delete all records</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
    <template slot="pageText" slot-scope="{}">
      Page {{ pagination.page }} of {{ getTotalPagesAllCryptoTraders }}
    </template>
  </v-data-table>
  <v-dialog persistent v-model="isConfirmationDeleteForever" max-width="500px">
    <v-card>
      <v-card-title>
        <span>Are You sure You want to delete the crypto trader? </span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-actions>
        <v-btn color="error" flat @click="deleteForever()">Delete forever</v-btn>
        <v-btn color="info" flat @click="hideConfirmationDeleteForever">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import { timeSettings } from '@/modules/settings/'
import { equals, path } from 'ramda'

export default {
  name: "crypto-traders-table",
  data() {
    return {
      pagination: {
        rowsPerPage: 50,
        sortBy: 'firstName',
        descending: false
      },
      getParams: null,
      isConfirmationDeleteForever: false,
      itemToDeleteForever: '',
      search: {
        registrationStatus: '',
        firstName: '',
        lastName: '',
        email: ''
      },
      pageRows: [50,100,200,{"text":"All","value":9999}],
      loading: false,
      headers: [
        { text: 'First name', value: 'firstName', search: false, sortable: true, width: 100 },
        { text: 'Last name', value: 'lastName', search: false, sortable: true, width: 100 },
        { text: 'Email', value: 'email', search: false, sortable: true, width: 100 },
        { text: 'Status', value: 'registrationStatus', search: false, width: 50 },
        { text: 'Edit', sortable: false, align: 'center', width: 30 },
        { text: 'Reject', sortable: false, align: 'center', width: 50 },
        { text: 'Delete all records', sortable: false, align: 'center', width: 30 }
      ],
      registrationStatuses: [
        'PendingPackageSelection',
        'Completed',
        'Rejected'
      ],
      compareParams: null,
      isForceRequest: false
    }
  },
  watch: {
    pagination: {
      handler () {
        this.fetchTableData()
      },
      deep: true
    },
    search: {
      handler () {
        this.fetchTableData()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'getCryptoTradersList',
      'getTotalPagesAllCryptoTraders',
      'getTotalItemsAllCryptoTraders'
    ]),
    totalItemsInTable () {
      return this.getTotalItemsAllCryptoTraders || (this.getTotalPagesAllCryptoTraders * this.pagination.rowsPerPage)
    },
    isRequest () {
      return !equals(this.compareParams, this.getParams) || this.isForceRequest
    }
  },
  methods: {
    ...mapActions([
      'fetchCryptoTradersList',
      'downloadCryptoTradersExcel',
      'deleteAllAttendeeRecords',
      'rejectAttendee'
    ]),
    async deleteForever () {
      try {
        await this.deleteAllAttendeeRecords([this.itemToDeleteForever])
      } catch (err) {
        throw err
      }
      this.hideConfirmationDeleteForever()
      this.isForceRequest = true
      this.fetchTableData()
    },
    async setStatusReject (id) {
      try {
        await this.rejectAttendee(id)
        this.isForceRequest = true
        this.fetchTableData()
      } catch (err) {
        throw err
      }
    },
    showConfirmationDeleteForever (item) {
      this.isConfirmationDeleteForever = true
      this.itemToDeleteForever = ''
      this.itemToDeleteForever = item.id
    },
    hideConfirmationDeleteForever () {
      this.isConfirmationDeleteForever = false
      this.itemToDeleteForever = ''
    },
    editCryptoTrader (trader) {
      this.$emit('editCryptoTrader', trader)
    },
    fetchTableData: debounce(async function () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.getTotalItemsAllAttendee : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: {
          registrationStatus: path(['registrationStatus'], this.search),
          firstName: path(['firstName'], this.search),
          lastName: path(['lastName'], this.search),
          email: path(['email'], this.search)
        },
        sort,
        name
      }
      this.getParams = getParams
      if (this.isRequest) await this.fetchCryptoTradersList(getParams)
      this.compareParams = getParams
      this.loading = false
      this.isForceRequest = false
    }, timeSettings.delayTime),
    async receiveRequiredData () {
      await this.fetchTableData()
    }
  },
  mounted () {
    this.receiveRequiredData()
    this.$bus.$on('reloadCryptoTraderTable', () => {
      this.isForceRequest = true
      this.fetchTableData()
    })
  },
  beforeDestroy () {
    this.$bus.$off('reloadCryptoTraderTable')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/CryptoTrader/CryptoTradersTable.vue